module.exports = __webpack_public_path__ + "static/media/paxos-map.69450104.jpg";